export const AGENCY_CREATE_FIELDS = {
  NAME: 'name',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zip',
  INDUSTRIES: 'industries',
};
export const AGENCY_ADDRESS_UPDATE_FIELDS = {
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zipcode',
};

export const AGENCY_INDUSTRY_UPDATE_FIELDS = {
  INDUSTRIES: 'industries',
};
